import { ExternalLink } from "lucide-react";

const TONE = {
  verified: "border-emerald-500/50 text-emerald-400",
  official: "border-white/30 text-white",
  benchmark: "border-ochre/50 text-ochre",
  estimate: "border-maasai/60 text-maasai",
  model: "border-maasai/60 text-maasai",
  unverified: "border-zinc-700 text-zinc-400",
};

const NAME = {
  verified: "Verified Data",
  official: "Official Statistic",
  benchmark: "Published Benchmark",
  estimate: "KSKF Estimate",
  model: "KSKF Model Output",
  unverified: "Unverified / Reported",
};

export const LABEL_KEYS = Object.keys(NAME);

const day = (value) => {
  if (!value) return "";
  const d = new Date(value);
  return Number.isNaN(d.getTime())
    ? String(value)
    : d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
};

/** The label chip on its own: what kind of figure this is. */
export const VerifyChip = ({ v, meaning, testId }) => {
  const key = TONE[v] ? v : "unverified";
  return (
    <span
      title={meaning || NAME[key]}
      data-testid={testId}
      className={`mono inline-block border px-2 py-1 text-[0.5rem] uppercase tracking-[0.16em] ${TONE[key]}`}
    >
      {NAME[key]}
    </span>
  );
};

/**
 * The full transparency stamp beside a figure: what kind of number it is, who published it and when,
 * and when we last reviewed it. Anything without a declared source reads as unverified.
 */
export const DataStamp = ({ source = {}, testId, className = "" }) => {
  const { verification, verification_label: vLabel, verification_meaning: meaning } = source;
  const publisher = source.publisher || source.source;
  return (
    <span className={`mono mt-3 flex flex-wrap items-center gap-x-3 gap-y-2 text-[0.5rem] uppercase tracking-[0.16em] text-zinc-500 ${className}`} data-testid={testId}>
      <VerifyChip v={verification} meaning={meaning || vLabel} />
      {publisher ? (
        source.url ? (
          <a
            href={source.url}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-1 text-zinc-300 underline decoration-zinc-700 underline-offset-2 hover:text-ochre"
          >
            {publisher} <ExternalLink size={9} />
          </a>
        ) : (
          <span className="text-zinc-300">{publisher}</span>
        )
      ) : null}
      {source.published ? <span>published {day(source.published)}</span> : <span>publication date not stated</span>}
      {source.reviewed ? <span>reviewed {day(source.reviewed)}</span> : null}
      {source.next_review ? <span className="text-zinc-600">next review {day(source.next_review)}</span> : null}
    </span>
  );
};
